const common = {
    no_data: 'Nenhum dado disponível',
    header: {
        business_name: 'Seu Negócio'
    },
    download_app: {
        text: 'Para usar a versão web do Simply, por favor, use um laptop ou PC.',
        button: 'Baixar versão móvel'
    },
    unknown: 'Desconhecido',
    request_error:
        'Ocorreu um erro. Tente novamente! Ou entre em contato com o suporte ao cliente para relatar seu problema.',
    home: 'Início',
    dashboard: 'Painel',
    product: 'Produto',
    add_product: 'Adicionar Produto',
    edit_product: 'Editar Produto',
    stock_in: 'Entrada de Estoque',
    Sales_Turnover: 'Faturamento de Vendas',
    profit: 'Lucro',
    stock_out: 'Saída de Estoque',
    staff: 'Equipe',
    stock_audit: 'Auditoria de Estoque',
    button: {
        save: 'Salvar',
        save_and_add_more: 'Salvar e Adicionar Mais',
        submit: 'Enviar',
        done: 'Concluído',
        edit: 'Editar',
        save_edit: 'Salvar Alterações',
        yes: 'Sim',
        clear: 'Limpar',
        delete: 'Excluir',
        cancel: 'Cancelar',
        reset: 'Redefinir'
    },
    select_date: 'Selecionar Data',
    select_action: 'Selecionar Ação',
    mandatory: ' *(Obrigatório)',
    not_mandatory: '(Não Obrigatório)',
    business: 'Negócio',
    account: 'Conta',
    profile: 'Perfil',
    setting: 'Configurações',
    whichLanguage: 'Português',
    headerDashboard: 'Torne-se um VIP',
    contact_us: 'Fale Conosco',
    logout: 'Sair',
    category: 'Categoria',
    data: 'Dados',
    history: 'Histórico',
    lowStockAlert: 'Alerta de Estoque Baixo',
    Expenses: 'Despesas',
    lowStockAlertButton: 'Adicionar Quantidade de Estoque de Segurança',
    message: {
        login_success: 'Login realizado com sucesso!',
        onboard_success: 'Hooray!! Sua jornada começou!',
        successfully_saved: 'Dados salvos com sucesso',
        successfully_deleted: 'Dados excluídos com sucesso',
        error_required_field: 'Campo obrigatório não pode estar vazio',
        no_access: 'Sem acesso',
        no_permission: "Você não tem permissão",
        error_update_history: 'Falha ao atualizar o histórico'
    },
    no_permission_dialog: {
        title: 'Sem Permissão',
        description: 'Você não tem permissão para ver as Despesas. Por favor, contate o administrador.'
    },
    feedback: 'Enviar feedback',
    contact: 'Contato',
    add: 'Adicionar',
    supplier: 'Fornecedor',
    customer: 'Cliente',
    random: 'Aleatório',
    scan: 'Escanear',
    enter: 'Entrar escaneando código de barras',
    terms: {
        text: 'Ao continuar, você concorda com a',
        link: 'Política de Privacidade'
    },
    others: 'Outros',
    calender: {
        presets: {
            today: 'Hoje',
            yesterday: 'Ontem',
            last_7_days: 'Últimos 7 Dias',
            last_30_days: 'Últimos 30 Dias',
            this_month: 'Este Mês',
            last_month: 'Último Mês',
            custom_range: 'Intervalo Personalizado'
        }
    },
    print_large: 'Imprimir Grande (A4)',
    print_letter: 'Imprimir Carta (US)',
    print_dot_matrix: 'Imprimir Grande (Matricial)',
    print_medium: 'Imprimir Médio (75mm)',
    print_small: 'Imprimir Pequeno (48mm)',
    format: 'Formato de papel',
    preview: 'Pré-visualização',
    view_invoice: 'Fatura',
    view_chalan: 'Challan',
    price: 'Preço',
    stock: 'Estoque',
    quantity: 'Quantidade',
    total: 'Total',
    print_footer_left: 'Criado por',
    print_footer_center: 'Impresso em',
    print_footer_date: 'em',
    print_to: 'Para',
    language: 'Português',
    dateStatus: 'Últimos 7 Dias',
    placeholder: 'Tipo de Transação',
    staffHistory: 'Selecionar Equipe',
    languageTitle: 'Português',
    date: 'Data',
    download: 'Baixar',
    download_excel: 'Baixar Excel',
    download_pdf: 'Baixar Código de Barras',
    currentTitle: 'Moeda',
    Selectperiod: 'Selecionar período',
    TransactionType: 'Tipo de Transação',
    SelectCustomer: 'Selecionar Cliente',
    invoice: 'Fatura',
    login: {
        google: 'Entrar com Google',
        apple: 'Entrar com Apple'
    },
    trusted_by: {
        title: 'Confiado por mais de 50.000 empresas \n em toda a Indonésia 🇮🇩'
    },
    privacyPolicyOne: 'Ao entrar, você concorda com a',
    privacyPolicyTwo: 'Política de Privacidade',
    manufacture: 'Fabricação',
    warehouse: 'Armazéns',
    error: {
        title: 'Ops! Algo deu errado',
        description: 'Ocorreu um erro inesperado. Tente atualizar a página ou voltar para a página inicial.',
        refresh: 'Atualizar página',
        go_back: 'Voltar para o início',
        not_found: 'Página não encontrada'
    },
    totalPurchasePrice: 'Preço Total de Compra',
    pageTotalPurchaseAmount: 'Valor Total de Compra por Página',
    approval_status: 'Status de aprovação',
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    select_fields: 'Selecionar Campos',
    syncWithTally: 'Sincronizar com Tally',
    importFromTally: 'Importar do Tally',
    exportToTally: 'Exportar para Tally',
    All: 'Todos',
    Approval: 'Aprovação'
}

export default common
